import qsa from "1dr-utils/helpers/elsForEach";

let APP = window.APP || {};

const serialize = function (obj, prefix) {
  let str = [],
    p;
  for (p in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, p)) {
      let k = prefix ? prefix + "[" + p + "]" : p,
        v = obj[p];
      str.push(
        v !== null && typeof v === "object"
          ? serialize(v, k)
          : encodeURIComponent(k) + "=" + encodeURIComponent(v),
      );
    }
  }
  return str.join("&");
};

APP.mccb = {};

APP.polyfillsReady.ready(() => {
  const handleResponse = function (json, form) {
    let resultMessage = Object.prototype.hasOwnProperty.call(json, "result")
      ? json.result
      : "unknown";
    let response = form.querySelector("[data-response]");
    let formFields = form.querySelector("[data-mcform]");

    if (resultMessage == "success") {
      let success =
        '<p class="mb-2">Thank you for signing up! Check your email, you will have received a confirmation email</p>';
      response.innerHTML = success;
      formFields.innerHTML = "";
    } else {
      let error;
      if (resultMessage == "error") {
        error = `<p class="mb-2 text-errorColor link-underline">${json.msg}</p>`;
      } else {
        console.warn("Unknown response", json);
        error = `<p class="mb-2 text-errorColor">Sorry, there was an error</p>`;
      }

      response.innerHTML = error;
    }
  };

  qsa("[data-mailchimp]", (form) => {
    form.addEventListener("submit", (e) => {
      e.preventDefault();

      let url = form.getAttribute("action");
      let d = new Date().getTime();
      let callbackString = "cb" + d;
      let data = new FormData(form);

      // JSON P:
      let plaindata = {};

      plaindata.SIGNUPORIG = data.get("SIGNUPORIG");
      plaindata.EMAIL = data.get("EMAIL");
      plaindata.c = "APP.mccb." + callbackString;

      url = url + "&" + serialize(plaindata);

      APP.mccb[callbackString] = function (json) {
        handleResponse(json, form);
        // erase self
        delete APP.mccb[callbackString];
      };

      let script = document.createElement("script");
      script.type = "text/javascript";
      script.src = url;
      document.getElementsByTagName("head")[0].appendChild(script);
    });
  });
});
